module.exports={
  "clima": {
    "clima-issue-1": {
      "clima-issue-1-answer-1": "Ampliar los programas de reembolso, como reemplazar el césped con paisajismo tolerante a la sequía y comprar electrodomésticos que ahorren agua en los hogares y las empresas",
      "clima-issue-1-answer-2": "Hacer que las reglas de riego en exteriores sean aún más estrictas y exigir su cumplimiento tanto en los hogares como en las empresas",
      "clima-issue-1-answer-3": "Prohibir el césped no tolerante a la sequía en nuevos desarrollos y entornos comerciales e industriales",
      "clima-issue-1-answer-4": "Acelerar los esfuerzos de reciclaje de agua y captura de aguas pluviales",
      "clima-issue-1-answer-5": "Ninguna de las opciones anteriores u otra cosa"
    },
    "clima-issue-2": {
      "clima-issue-2-answer-1": "Brindarles más apoyo directo durante las olas de calor extremo, como abrir más centros de enfriamiento, proporcionar más aire acondicionado subsidiado y asistencia en las facturas de servicios públicos, etc.",
      "clima-issue-2-answer-2": "Mejorar la infraestructura de enfriamiento en vecindarios con menos árboles, como plantar árboles, construir estructuras que den sombra, ampliar los espacios verdes, etc.",
      "clima-issue-2-answer-3": "Exigir estándares de enfriamiento interior para hogares y lugares de trabajo para que los constructores y propietarios deban incorporar resiliencia al calor",
      "clima-issue-2-answer-4": "Aumentar los mensajes públicos sobre los peligros del calor extremo y sobre cómo protegerse y proteger a sus seres queridos",
      "clima-issue-2-answer-5": "Ninguna de las opciones anteriores u otra cosa"
    },
    "clima-issue-3": {
      "clima-issue-3-answer-1": "Ampliar el transporte público y las zonas para ciclistas y peatones",
      "clima-issue-3-answer-2": "Ampliar los programas de reembolso y brindar otros incentivos para que más personas usen vehículos eléctricos o híbridos, o utilicen el transporte público",
      "clima-issue-3-answer-3": "Ampliar la red de recarga de vehículos eléctricos de la ciudad",
      "clima-issue-3-answer-4": "Redoblar el esfuerzo con las inversiones en tecnología de combustible de hidrógeno",
      "clima-issue-3-answer-5": "Implementar restricciones de vehículos con motor de gasolina",
      "clima-issue-3-answer-6": "Ninguna de las opciones anteriores u otra cosa"
    },
    "clima-issue-4": {
      "clima-issue-4-answer-1": "Aumentar los recursos para combatir incendios",
      "clima-issue-4-answer-2": "Trabajar con los constructores para fortalecer las estructuras, como requerir estándares de construcción que sean más estrictos que los del estado",
      "clima-issue-4-answer-3": "Trabajar con los propietarios para fortalecer las estructuras y garantizar un espacio defendible alrededor de ellas mediante incentivos o multas",
      "clima-issue-4-answer-4": "Prohibir o restringir nuevos desarrollos en zonas propensas a incendios",
      "clima-issue-4-answer-5": "Ninguna de las opciones anteriores u otra cosa"
    }
  },
  "personas-sin-vivienda": {
    "personas-sin-vivienda-issue-1": {
      "personas-sin-vivienda-issue-1-answer-1": "Mantenerse como está",
      "personas-sin-vivienda-issue-1-answer-2": "Mantenerse, pero ampliar el apoyo a las personas sin hogar",
      "personas-sin-vivienda-issue-1-answer-3": "Cambiarse o cambiar la forma en que se implementa",
      "personas-sin-vivienda-issue-1-answer-4": "Derogarse"
    },
    "personas-sin-vivienda-issue-2": {
      "personas-sin-vivienda-issue-2-answer-1": "Totalmente de acuerdo",
      "personas-sin-vivienda-issue-2-answer-2": "Parcialmente de acuerdo",
      "personas-sin-vivienda-issue-2-answer-3": "Algo en desacuerdo",
      "personas-sin-vivienda-issue-2-answer-4": "Muy en desacuerdo "
    },
    "personas-sin-vivienda-issue-3": {
      "personas-sin-vivienda-issue-3-answer-1": "Sí, la crisis de personas sin hogar hace que todos corran más peligro",
      "personas-sin-vivienda-issue-3-answer-2": "Es discutible",
      "personas-sin-vivienda-issue-3-answer-3": "No"
    },
    "personas-sin-vivienda-issue-4": {
      "personas-sin-vivienda-issue-4-answer-1": "Construir más viviendas asequibles permanentes",
      "personas-sin-vivienda-issue-4-answer-2": "Construir más refugios temporales",
      "personas-sin-vivienda-issue-4-answer-3": "Ampliar las instalaciones de salud mental y el acceso a ellas",
      "personas-sin-vivienda-issue-4-answer-4": "Crear más puestos de trabajo",
      "personas-sin-vivienda-issue-4-answer-5": "Reducir el límite de los aumentos de alquiler en las viviendas de alquiler controlado de la ciudad",
      "personas-sin-vivienda-issue-4-answer-6": "Ninguna de las opciones anteriores u otra cosa"
    }
  },
  "economia": {
    "economia-issue-1": {
      "economia-issue-1-answer-1": "Aumentar la inversión equitativa en infraestructura para aminorar el tráfico (es decir, flechas para girar a la izquierda, cruces peatonales de alta visibilidad, extensiones de acera, rotondas, etc.)",
      "economia-issue-1-answer-2": "Abogar por las cámaras de velocidad (requeriría legislación estatal)",
      "economia-issue-1-answer-3": "Ordenar a la policía que emita más multas de tránsito",
      "economia-issue-1-answer-4": "Ampliar el trabajo sobre la reducción de los límites de velocidad",
      "economia-issue-1-answer-5": "Crear más zonas libres de autos en toda la ciudad",
      "economia-issue-1-answer-6": "Ninguna de las opciones anteriores u otra cosa"
    },
    "economia-issue-2": {
      "economia-issue-2-answer-1": "Mantenerlos como están",
      "economia-issue-2-answer-2": "Disminuirlos",
      "economia-issue-2-answer-3": "Aumentarlos",
      "economia-issue-2-answer-4": "Eliminarlos"
    },
    "economia-issue-3": {
      "economia-issue-3-answer-1": "Eliminarlas ahora",
      "economia-issue-3-answer-2": "Dejar que venzan",
      "economia-issue-3-answer-3": "Extenderlas"
    },
    "economia-issue-4": {
      "economia-issue-4-answer-1": "Es adecuado",
      "economia-issue-4-answer-2": "Es demasiado bajo",
      "economia-issue-4-answer-3": "A ese nivel, supone una carga demasiado grande para las pequeñas empresas",
      "economia-issue-4-answer-4": "No apoyo un salario mínimo"
    },
    "economia-issue-5": {
      "economia-issue-5-answer-1": "Sí",
      "economia-issue-5-answer-2": "No"
    }
  },
  "policia": {
    "policia-issue-1": {
      "policia-issue-1-answer-1": "Aumentar los agentes al límite autorizado",
      "policia-issue-1-answer-2": "Presionar para autorizar aún más agentes",
      "policia-issue-1-answer-3": "Mantenerlo en el nivel actual",
      "policia-issue-1-answer-4": "Reducirlo aún más"
    },
    "policia-issue-2": {
      "policia-issue-2-answer-1": "Permanecer igual",
      "policia-issue-2-answer-2": "Aumentar",
      "policia-issue-2-answer-3": "Disminuir"
    },
    "policia-issue-3": {
      "policia-issue-3-answer-1": "Ampliar el número de Unidades de Evaluación Mental disponibles (actualmente solo hay 10-12), que forman parejas de médicos de salud mental con agentes armados",
      "policia-issue-3-answer-2": "Aumentar la capacitación de los agentes en relación a la respuesta a las crisis de salud mental ",
      "policia-issue-3-answer-3": "Mejorar la capacitación de los operadores para que puedan canalizar las llamadas al 988, la nueva línea de crisis de salud mental",
      "policia-issue-3-answer-4": "Ninguna de las opciones anteriores u otra cosa"
    },
    "policia-issue-4": {
      "policia-issue-4-answer-1": "Sí",
      "policia-issue-4-answer-2": "No"
    },
    "policia-issue-5": {
      "policia-issue-5-answer-1": "Se alinea ampliamente con mis creencias",
      "policia-issue-5-answer-2": "No estoy de acuerdo con parte de su agenda",
      "policia-issue-5-answer-3": "No estoy de acuerdo con la mayor parte de su agenda",
      "policia-issue-5-answer-4": "No estoy de acuerdo con la mayor parte de su agenda y creo que debería haber sido destituido de su cargo"
    },
    "policia-issue-6": {
      "policia-issue-6-answer-1": "Aumentar los fondos para la policía comunitaria",
      "policia-issue-6-answer-2": "Aumentar la capacitación de los agentes en técnicas de desescalada",
      "policia-issue-6-answer-3": "Reemplazar al jefe de policía actual",
      "policia-issue-6-answer-4": "Ninguna de las opciones anteriores u otra cosa"
    }
  }
}